import React, { Fragment, useEffect } from "react";
import PageTitle from "../../Layout/AppMain/PageTitle";
import { Button, Col, CustomInput, Row } from "reactstrap";
import { api, userService } from "../../_services";
import Loader from "react-loaders";
import { toast } from "react-toastify";
import QuickBooksLoadingModal from "./QuickBooksLoadingModal";
import DatePicker from "react-datepicker";
import moment from "moment";

const Quickbooks = (props) => {
  const currentUser = userService.getLoggedInUser();
  const [isLoading, setIsLoading] = React.useState(false);
  const [entity, setEntity] = React.useState(null);
  const [isSyncing, setIsSyncing] = React.useState(false);
  const [quickBooksError, setQuickBooksError] = React.useState("");
  const [isTesting, setIsTesting] = React.useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setIsLoading(true);
    let e = await api.getEntityById(currentUser.entityId);
    setEntity(e);
    setIsLoading(false);
  };

  const changeEntityProp = (prop, value) => {
    setEntity((prev) => ({
      ...prev,
      [prop]: value,
    }));
  };

  const syncNow = async () => {
    setIsSyncing(true);

    api.syncQuickBooksCustomers(currentUser.entityId).then(
      (data) => {
        setIsSyncing(false);
      },
      (err) => {
        setQuickBooksError(err);
      },
    );
  };

  const saveEntity = async () => {
    try {
      await api.updateEntity(entity, true);
      toast.success("Configuration saved");
    } catch (error) {
      toast.error("Error saving configuration");
    }
  };

  const initIntuit = async () => {
    let url = await api.getIntuitAuthUrl(currentUser.entityId);
    if (url) {
      window.location.href = url;
    }
  };

  const testIntuit = async () => {
    try {
      setIsTesting(true);
      let ret = await api.testQuickbooks(currentUser.entityId);
      alert(ret);
      setIsTesting(false);
    } catch (error) {
      alert(error)
      setIsTesting(false);
    }
  }

  const quickbooksDisabled =
    entity?.quickBooksTokenInfo == undefined ||
    entity?.quickBooksTokenInfo == null ||
    entity?.quickBooksTokenInfo == "";

  return (
    <Fragment>
      <PageTitle heading="QuickBooks" />
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && entity != null && (
        <Row style={{ marginBottom: "100px" }}>
          <Col md="6">
            <h4>
              <b>QuickBooks configuration</b>
            </h4>
            <div className="form-group">
              <label>QuickBooks Client ID</label>
              <CustomInput
                type="text"
                value={entity.quickBooksClientID}
                onChange={(e) => {
                  changeEntityProp("quickBooksClientID", e.target.value);
                }}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>QuickBooks Client Secret</label>
              <CustomInput
                type="text"
                value={entity.quickBooksClientSecret}
                onChange={(e) => {
                  changeEntityProp("quickBooksClientSecret", e.target.value);
                }}
                className="form-control"
              />
            </div>
            <div className="form-group ">
              <label htmlFor="startDate">Process Invoices From</label>

              <DatePicker
                className="form-control"
                selected={
                  entity.quickBooksStartDate
                    ? moment(entity.quickBooksStartDate, "YYYY-MM-DD").toDate()
                    : null
                }
                onChange={(date) => {
                  console.log("-------------------");
                  console.log(date);
                  console.log(moment(date).format("YYYY-MM-DD"));
                  changeEntityProp(
                    "quickBooksStartDate",
                    moment(date).format("YYYY-MM-DD"),
                  );
                }}
                placeholderText="Start date..."
              />
            </div>
            <div className="form-group">
              <label>Periodicity (0-24 hours)</label>
              <CustomInput
                type="number"
                value={entity.quickBooksPeriodicityInHours}
                onChange={(e) => {
                  if (e.target.value <= 24)
                    changeEntityProp(
                      "quickBooksPeriodicityInHours",
                      e.target.value,
                    );
                }}
                className="form-control"
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "20px",
              }}
            >
              <div>
                <CustomInput
                  id={`showDetails`}
                  type="radio"
                  value={true}
                  label="Show Details"
                  checked={entity.quickBooksShowDetails == true}
                  onChange={(e) =>
                    changeEntityProp("quickBooksShowDetails", true)
                  }
                ></CustomInput>
              </div>
              <div style={{ marginLeft: "20px" }}>
                <CustomInput
                  id={`showSummary`}
                  type="radio"
                  value={false}
                  label="Show Summary"
                  checked={entity.quickBooksShowDetails == false}
                  onChange={(e) =>
                    changeEntityProp("quickBooksShowDetails", false)
                  }
                ></CustomInput>
              </div>
            </div>
            <Button color="primary" type="button" onClick={saveEntity}>
              Save
            </Button>
            <div style={{ marginTop: 20 }}>
              <p>
                <b>Note:</b> When changing Client ID or Client Secret, after
                saving, please make sure to re-init QuickBooks connection by
                clicking the "Init QuickBooks" button.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Button color="primary" type="button" onClick={initIntuit}>
                  Init QuickBooks
                </Button>
                <Button color="primary" type="button" onClick={testIntuit} disabled={isTesting}>
                  Test QuickBooks
                </Button>
              </div>
            </div>
          </Col>
          <Col md="6">
            <Button
              color="primary"
              type="button"
              onClick={syncNow}
              disabled={isSyncing || quickbooksDisabled}
            >
              Sync Now
            </Button>
          </Col>
        </Row>
      )}
      <QuickBooksLoadingModal isLoading={isSyncing} error={quickBooksError} />
    </Fragment>
  );
};

export default Quickbooks;
